import React, { DetailedHTMLProps, InputHTMLAttributes } from 'react';
import cn from 'classnames';

export const inputStyles =
  'px-4 py-1 mb-6 mr-1 h-15 text-base border-2 border-gray-900 rounded-full cursor-pointer w-full appearance-none block outline-none focus:border-yellow-500';
export const Input = React.forwardRef<HTMLInputElement, DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>>(
  ({ children, className, ...inputProps }, ref) => {
    return <input className={cn(inputStyles, className)} {...inputProps} ref={ref} />;
  }
);
